import { render, staticRenderFns } from "./SmsSetting.vue?vue&type=template&id=2a4f4b1d&scoped=true"
import script from "./SmsSetting.vue?vue&type=script&lang=js"
export * from "./SmsSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4f4b1d",
  null
  
)

export default component.exports